/**
 * Direct-route capability map. More-specific entries must come first.
 * The names match backend permission/capability names used by the menu.
 */
export const route_acl_map = [
  [/^\/agents-management\/[^/]+\/test(?:\/|$)/, "test_agent"],
  [/^\/agents-test(?:\/|$)/, "test_agent"],
  [/^\/agents-instructions(?:\/|$)/, "prompts_instructions"],
  [/^\/agent-instructions(?:\/|$)/, "prompts_instructions"],
  [/^\/agents-management(?:\/|$)/, "agents_management"],
  [/^\/agents\/[^/]+\/[^/]+\/documents(?:\/|$)/, "agents_management"],
  [/^\/analytics(?:\/|$)/, "conversations_analytics"],
  [/^\/(?:conversations|messages|attachments)-analytics(?:\/|$)/, "conversations_analytics"],
  [/^\/agent-analytics(?:\/|$)/, "conversations_analytics"],
  [/^\/sites-devices(?:\/|$)/, "sites_and_devices"],
  [/^\/data-library(?:\/|$)/, "data_library"],
  [/^\/data-source(?:\/|$)/, "data_source"],
  [/^\/data-mappings(?:\/|$)/, "integrations"],
  [/^\/integrations(?:\/|$)/, "integrations"],
  [/^\/jobs(?:\/|$)/, "jobs"],
  [/^\/configurations(?:\/|$)/, "configurations"],
  [/^\/themes(?:\/|$)/, "themes"],
  [/^\/media-library(?:\/|$)/, "media_library"],
  [/^\/campaigns(?:\/|$)/, "campaigns"],
  [/^\/users(?:\/|$)/, "users"],
  // NOTE: `/companies` is deliberately absent. It serves double duty — the
  // super-admin "All Companies" view AND the mandatory company picker every
  // multi-company user is sent to right after login. Gating it on
  // `all_companies` here 404s a multi-company team member whose role omits that
  // capability, even though the route's own guard (`beforeEnterAllCompanies`)
  // permits multi-company users by design. That guard stays the authority for
  // route access; `all_companies` still governs the sidebar item's visibility
  // via its acl_name in sideMenuItems.
  [/^\/overview(?:\/|$)/, "overview"],
  [/^\/dashboard(?:\/|$)/, "overview"],
];

export const capabilityForRoute = (path) =>
  route_acl_map.find(([pattern]) => pattern.test(path))?.[1] || null;
